import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { updateIsFromConcurrent } from '../actions/form';
import { getIsFromConcurrent, getErrors } from '../reducers/form';
import cx from 'classnames';
import Dropdown from 'common/components/Dropdown';

const mapStateToProps = state => ({
  isFromConcurrent: getIsFromConcurrent(state),
  errors: getErrors(state),
});
const mapDispatchToProps = dispatch => ({
  updateIsFromConcurrent: isFromConcurrent =>
    dispatch(updateIsFromConcurrent(isFromConcurrent)),
});

const ExistingCaseConcurrent = ({
  isFromConcurrent,
  updateIsFromConcurrent,
  errors,
}) => {
  const fieldClass = cx('field required', {
    error: errors.includes('isFromConcurrent'),
  });

  const concurrentOptions = [
    {
      text: "Non, c'était déjà mon chantier",
      value: false,
    },
    {
      text: "Oui, c'était le chantier d'un concurrent",
      value: true,
    },
  ];

  const renderDefault = () => {
    const selectedValue = concurrentOptions.find(
      r => r.value === isFromConcurrent
    );
    if (selectedValue) {
      return <div className="text">{selectedValue.text}</div>;
    }
    return <div className="default text">Origine du chantier</div>;
  };

  const itemClassName = value => {
    const active = isFromConcurrent === value;
    return cx('item', {
      active: active,
      selected: active,
    });
  };

  const renderItem = item => (
    <div
      key={item.value}
      data-value={item.value}
      className={itemClassName(item.value)}
    >
      {item.text}
    </div>
  );

  const onDropdownChange = (value, text, choice) => {
    updateIsFromConcurrent(value === 'true');
  };

  return (
    <div className="ui segment">
      <div className="two fields">
        <div className={fieldClass}>
          <label>
            Ce nouveau chantier vient-il d'être récupéré à la concurrence ?
          </label>
          <Dropdown
            name="is_from_concurrent"
            value={isFromConcurrent}
            items={concurrentOptions}
            renderDefault={renderDefault}
            renderItem={renderItem}
            onChange={onDropdownChange}
          />
        </div>
        <div className="field" />
      </div>
    </div>
  );
};

ExistingCaseConcurrent.propTypes = {
  isFromConcurrent: PropTypes.bool.isRequired,
  updateIsFromConcurrent: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExistingCaseConcurrent);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/components/ExistingCaseConcurrent.js